var TabApprovalsEquipmentsAttachmentsModule = /** @class */ (function () {
    function TabApprovalsEquipmentsAttachmentsModule() {
    }
    return TabApprovalsEquipmentsAttachmentsModule;
}());
export { TabApprovalsEquipmentsAttachmentsModule };
